"use strict";

export const buildAssetUrl = ({
  staticMFEUrl,
  mfeAppName,
  asset
}) => {
  const appFolder = mfeAppName;
  return `${staticMFEUrl}/${appFolder}/${asset}`;
};